/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkProjectrevenue } from '../models/work-projectrevenue';

@Injectable({ providedIn: 'root' })
export class WorkProjectrevenuesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectrevenuesV1ControllerFindByProjectId()` */
  static readonly ProjectrevenuesV1ControllerFindByProjectIdPath = '/v1/projectrevenues/byProjectId/{projectId}';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectrevenuesV1ControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectrevenuesV1ControllerFindByProjectId$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectrevenue>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectrevenuesService.ProjectrevenuesV1ControllerFindByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectrevenue>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectrevenuesV1ControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectrevenuesV1ControllerFindByProjectId(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectrevenue>> {
    return this.projectrevenuesV1ControllerFindByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectrevenue>>): Array<WorkProjectrevenue> => r.body)
    );
  }

}
